module.exports = __webpack_public_path__ + "static/media/howitworks-5.ed6d889f.png";